var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmbulance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ambulance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.0001 7.99814V7.49814C2.99126 7.36454 3.01107 7.23058 3.05819 7.10525C3.10532 6.97991 3.17868 6.8661 3.27337 6.77141C3.36805 6.67673 3.48187 6.60337 3.6072 6.55624C3.73253 6.50911 3.86649 6.48931 4.0001 6.49814H14.0001C14.1337 6.48931 14.2677 6.50911 14.393 6.55624C14.5183 6.60337 14.6321 6.67673 14.7268 6.77141C14.8215 6.8661 14.8949 6.97991 14.942 7.10525C14.9891 7.23058 15.0089 7.36454 15.0001 7.49814V15.5981C15.0001 15.979 14.9251 16.3561 14.7793 16.7079C14.6336 17.0598 14.42 17.3795 14.1507 17.6488C13.8814 17.918 13.5617 18.1317 13.2099 18.2774C12.858 18.4231 12.4809 18.4981 12.1001 18.4981V18.4981",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 11.4981H18.8C19.2359 11.4772 19.6639 11.6198 20 11.8981L21.2 12.7981C21.4434 12.989 21.6415 13.2315 21.7798 13.5082C21.9182 13.7849 21.9934 14.0888 22 14.3981V18.4981",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.00005 18.5008H3.50005C3.43324 18.5052 3.36627 18.4953 3.3036 18.4717C3.24093 18.4482 3.18402 18.4115 3.13668 18.3641C3.08934 18.3168 3.05266 18.2599 3.0291 18.1972C3.00553 18.1346 2.99563 18.0676 3.00005 18.0008V16.8008",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6 13.5H2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3 11H8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8 20.5C8.82843 20.5 9.5 19.8284 9.5 19C9.5 18.1716 8.82843 17.5 8 17.5C7.17157 17.5 6.5 18.1716 6.5 19C6.5 19.8284 7.17157 20.5 8 20.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18 20.5C18.8284 20.5 19.5 19.8284 19.5 19C19.5 18.1716 18.8284 17.5 18 17.5C17.1716 17.5 16.5 18.1716 16.5 19C16.5 19.8284 17.1716 20.5 18 20.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/Ambulance.ea03eeed.svg";
export { ForwardRef as ReactComponent };